// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingBackground_root__nHw5_"};